<template>
  <div class="v-short-answer container">
    <input
      type="text"
      class="v-short-answer__input browser-default"
      placeholder="Digite aqui..."
      maxlength="120"
      v-model="value"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
  name: "VShortAnswer",
  data: () => ({ value: "" }),
  computed: {
    ...mapState("Quiz", ["currentQuestion"])
  },
  methods: {
    ...mapMutations("Quiz", ["updateResponse"])
  },
  watch: {
    value(value) {
      this.updateResponse({
        question: this.currentQuestion.uuid,
        response: value
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-short-answer {
  &__input {
    min-height: 64px;
    font-size: 24px;
    border: none;
    outline: none;
    background: #d0d0d0;
    border-radius: 8px;
    padding: 16px 32px;
    width: 100%;

    &::placeholder {
      color: #8c8c8c;
    }
  }
}
</style>
